function fileToBase64(file) {
	return new Promise((resolve, reject) => {
		let reader = new FileReader();
		let fileResult = ""
		reader.readAsDataURL(file);
		reader.onload = function() {
			//去除头部data:image/jpg;base64,留下base64编码后的字符串
			let index=reader.result.indexOf(',')
			let str=reader.result.slice(index + 1,reader.result.length)
			fileResult = str;
		};
		reader.onerror = function(error) {
			reject(error);
		};
		reader.onloadend = function() {
			resolve(fileResult);
		};
	});
}


//计算文件大小
function lzGetFileSize(appByts) {
	var mb = 1024 * 1024;
	if (appByts > mb) {
		var bb = appByts / (1024 * 1024);
		bb = Math.floor(bb * 100) / 100;
		return bb + "MB";
	}
	var bk = appByts / 1024;
	bk = bk.toFixed(1);
	return bk + "KB";
}
//计算文件格式传入后缀
function lzGetFileType(suffix) {
	if (suffix == 'jpg' || suffix == 'jpeg' || suffix == "png" || suffix == "bpm" || suffix == "BPM" || suffix == 'PNG' ||
		suffix ==
		'gif' || suffix == 'GIF') {
		return require('../../img/fileIcon/image.png')
	} else if (suffix == 'doc' || suffix == 'docx' || suffix == 'DOC' || suffix == 'DOCX') {
		return require('../../img/fileIcon/doc.png')
	} else if (suffix == 'xlsx' || suffix == 'xls' || suffix == 'XLSX' || suffix == 'XLS') {
		return require('../../img/fileIcon/xlsx.png')
	} else if (suffix == 'txt' || suffix == 'TXT') {
		return require('../../img/fileIcon/TXT.png')
	} else if (suffix == 'zip' || suffix == 'rar') {
		return require('../../img/fileIcon/zip.png')
	} else if (suffix == 'pdf' || suffix == 'PDF') {
		return require('../../img/fileIcon/pdf.png')
	} else if (suffix == 'mp4' || suffix == 'wmv' || suffix == 'avi' || suffix == 'MP4' || suffix == 'WMV' || suffix ==
		'AVI') {
		return require('../../img/fileIcon/shipin.png')
	} else if (suffix == 'mp3' || suffix == 'm4a' || suffix == 'wma' || suffix == 'MP3' || suffix == 'M4A' || suffix ==
		'WMA') {
		return require('../../img/fileIcon/yinpin.png')
	} else {
		return require('../../img/fileIcon/weizhi.png')
	}
}
//判断打开的文件类型
function lzGetTypeSuffix(suffix) {
	let result = ''
	const imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'PNG', 'JPG', 'JPEG', 'BMP', 'GIF'];
	const wordList = ['doc', 'xls', 'ppt', 'pdf', 'docx', 'xlsx', 'pptx', 'DOC', 'XLS', 'PPT', 'PDF', 'DOCX', 'XLSX',
		'PPTX', 'txt'
	];
	const videoList = ['mp4', 'wmv', 'avi', 'MP4', 'WMV', 'AVI'];
	const audioList = ['mp3', 'm4a', 'wma', 'MP3', 'M4A', 'WMA'];
	result = imglist.find(item => item === suffix);
	if (result) {
		return 'image';
	}
	result = wordList.find(item => item === suffix);
	if (result) {
		return 'word';
	}
	result = videoList.find(item => item === suffix);
	if (result) {
		return 'video';
	}
	result = audioList.find(item => item === suffix);
	if (result) {
		return 'audio';
	}

}

export default {
	fileToBase64,
	lzGetFileSize,
	lzGetFileType,
	lzGetTypeSuffix,
}


// WEBPACK FOOTER //
// ./static/js/function/file.js